var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiddleStepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 32,
    viewBox: "0 0 180 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33289 1.37634C0.985361 1.07235 1.20036 0.5 1.66208 0.5H166.61C166.973 0.5 167.324 0.631819 167.598 0.870979L179.244 14.871C179.927 15.4686 179.927 16.5314 179.244 17.129L167.598 31.129C167.324 31.3682 166.973 31.5 166.61 31.5H1.66207C1.20036 31.5 0.985352 30.9277 1.33289 30.6237L12.4673 17.129C13.1505 16.5314 13.1505 15.4686 12.4673 14.871L1.33289 1.37634Z",
    stroke: "#39BAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleStepIcon);
export default __webpack_public_path__ + "static/media/middle-step-icon.3dec05069922ba467e5266ff831a9085.svg";
export { ForwardRef as ReactComponent };